import { z } from 'zod';

/** TOS / S3 兼容对象存储配置（前端可填，或运维端配） */
export const TosConfigSchema = z.object({
  bucket: z.string().default(''),
  prefix: z.string().default(''),
  accessKey: z.string().default(''),
  secretKey: z.string().default(''),
  region: z.string().default('cn-beijing'),
  endpoint: z.string().default(''),
});
export type TosConfig = z.infer<typeof TosConfigSchema>;

/** 输出位置 */
export const OutputConfigSchema = z.object({
  bucket: z.string().default(''),
  prefix: z.string().default('output/'),
});
export type OutputConfig = z.infer<typeof OutputConfigSchema>;

/** 默认生成参数 */
export const GenDefaultsSchema = z.object({
  resolution: z.enum(['720p', '1080p', '2K']).default('1080p'),
  duration: z.enum(['5 秒', '10 秒', '15 秒']).default('10 秒'),
  concurrency: z.coerce.number().int().min(1).max(16).default(4),
  retries: z.coerce.number().int().min(1).max(5).default(1),
});
export type GenDefaults = z.infer<typeof GenDefaultsSchema>;

/** 主题 */
export const ThemeSchema = z.enum(['system', 'light', 'dark']);
export type Theme = z.infer<typeof ThemeSchema>;

/** 全量前端配置（localStorage 持久化） */
export const AppConfigSchema = z.object({
  tos: TosConfigSchema.default({}),
  output: OutputConfigSchema.default({}),
  gen: GenDefaultsSchema.default({}),
  theme: ThemeSchema.default('system'),
});
export type AppConfig = z.infer<typeof AppConfigSchema>;
